/**
 * Re-handshake silenzioso: ri-firma pair_accept + queue_update senza UI né unpair.
 */
import { getPublicKeyBase64 } from '../storage/keyStore.ts'
import { getInboundQueueId, getSessionToken } from '../storage/sessionStore.ts'
import { ensureInboundQueue } from '../identity/ZionIdentityManager.ts'
import {
  broadcastQueueUpdate,
  ensureSocketReady,
  refreshSessionTokenTransparent,
  sendPairAccept,
} from '../socket2/ZionSocketClient.ts'
import type { ZionContact } from '../storage/pairingStore.ts'
import { getBaseNickname } from '../identity/ZionIdentityManager.ts'

export async function silentReHandshakeToContact(contact: ZionContact): Promise<boolean> {
  const peerSession = contact.sessionToken?.trim()
  if (!peerSession) return false

  let mySession =
    (await refreshSessionTokenTransparent())?.trim() ||
    (await getSessionToken())?.trim() ||
    ''
  if (!mySession) return false

  const { queueId } = await ensureInboundQueue()
  const myPublicKey = (await getPublicKeyBase64()).trim()
  if (!myPublicKey) return false

  const myNickname = (await getBaseNickname()).trim() || 'zion-user'

  const ok = await sendPairAccept({
    toSessionToken: peerSession,
    mySessionToken: mySession,
    myPublicKey,
    myNickname,
    myQueueId: queueId || (await getInboundQueueId())?.trim() || '',
  })
  if (!ok) return false

  const q = queueId || (await getInboundQueueId())?.trim() || ''
  if (q) {
    await broadcastQueueUpdate(mySession, q, [peerSession])
  }

  await ensureSocketReady()
  return true
}
